import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Blog.css';

function Blog() {
  const API_URL = 'https://www.fintexl.com'; // ✅ Added this

  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [formData, setFormData] = useState({
    previewImage: null,
    originalFile: null,
    title: '',
    description: ''
  });
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState(null);

  // Fetch blogs from backend on component mount
  useEffect(() => {
    fetch(`${API_URL}/api/blogs`) // ✅ Updated URL
      .then(res => res.json())
      .then(data => setUploadedFiles(data))
      .catch(err => console.error('Error fetching blogs:', err));
  }, []);

  const handleInputChange = (e) => {
    const { name, value, files } = e.target;
    if (files) {
      setFormData(prev => ({ ...prev, [name]: files[0] }));
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleFileUpload = async (e) => {
    e.preventDefault();
    setError(null);

    if (!formData.previewImage || !formData.originalFile || !formData.title) {
      setError('Please fill all required fields.');
      return;
    }

    const data = new FormData();
    data.append('previewImage', formData.previewImage);
    data.append('originalFile', formData.originalFile);
    data.append('title', formData.title);
    data.append('description', formData.description);

    setUploading(true);

    try {
      const response = await fetch(`${API_URL}/api/blogs`, { // ✅ Updated URL
        method: 'POST',
        body: data
      });

      if (!response.ok) {
        throw new Error('Upload failed');
      }

      const newBlog = await response.json();
      setUploadedFiles(prev => [...prev, newBlog]);
      setFormData({
        previewImage: null,
        originalFile: null,
        title: '',
        description: ''
      });
      e.target.reset();
    } catch (err) {
      setError('Failed to upload blog. Please try again.');
      console.error(err);
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="service-page">
      {/* Hero Section */}
      <section
        className="hero-image-section"
        style={{ backgroundImage: "url('/images/blogs_fintexl.png')" }}
      >
        <div className="hero-text-container">
          <h1>Our Blog</h1>
          <p>Insights, knowledge, and updates from the world of finance and compliance</p>
        </div>
      </section>

      {/* Knowledge Content */}
      <section className="service-content">
        <div className="content-left">
          <h2>FINTEXL Knowledge Center</h2>
          <p>The Knowledge Center at FINTEXL is a hub of insights, research, and resources designed to keep our clients informed and ahead of industry trends. We provide expert analysis, whitepapers, case studies, and updates on regulatory changes to empower your business decisions.</p>
          <p>Our team continuously curates and develops content that addresses the evolving challenges and opportunities in tax consulting, financial advisory, and compliance.</p>
          <p>Explore our Knowledge Center to gain valuable knowledge and stay connected with the latest developments.</p>
        </div>
      </section>

      {/* Upload Section */}
      <section className="upload-section">
        <h2>Upload Files</h2>
        <form className="upload-form" onSubmit={handleFileUpload}>
          <div className="form-row">
            <label>Upload Preview Image:</label>
            <input type="file" name="previewImage" onChange={handleInputChange} required />
          </div>

          <div className="form-row">
            <label>Upload Original File:</label>
            <input type="file" name="originalFile" onChange={handleInputChange} required />
          </div>

          <div className="form-row">
            <label>Enter a Title:</label>
            <input type="text" name="title" placeholder="Enter a title" value={formData.title} onChange={handleInputChange} required />
          </div>

          <div className="form-row">
            <label>Enter a Description:</label>
            <textarea name="description" placeholder="Enter a description" value={formData.description} onChange={handleInputChange}></textarea>
          </div>

          {error && <p className="error-message">{error}</p>}

          <div className="form-button">
            <button type="submit" disabled={uploading}>{uploading ? 'Uploading...' : 'Upload File'}</button>
          </div>
        </form>

        {/* Uploaded Files Preview Section */}
        <div className="uploaded-files">
          {uploadedFiles.map((file) => (
            <div key={file.id} className="uploaded-file-card">
              <img src={file.previewUrl} alt={file.title} /> {/* ✅ Already full URL */}
              <h4>{file.title}</h4>
              <p>
                {file.description.length > 100
                  ? file.description.substring(0, 100) + '...'
                  : file.description}
              </p>
              {file.description.length > 100 && (
                <div style={{ textAlign: 'center', marginTop: '10px' }}>
                  <Link to={`/blog/${file.id}`} className="read-more-button">
                    Read More
                  </Link>
                </div>
              )}
              <div
                className="delete-area"
                style={{ cursor: 'pointer', height: '20px', marginTop: '10px' }}
                onClick={(() => {
                  let clickCount = 0;
                  let timer = null;
                  return (event) => {
                    clickCount++;
                    if (clickCount === 3) {
                      deleteBlog(file.id);
                      clickCount = 0;
                      clearTimeout(timer);
                    } else {
                      clearTimeout(timer);
                      timer = setTimeout(() => {
                        clickCount = 0;
                      }, 500);
                    }
                  };
                })()}
              />
            </div>
          ))}
        </div>
      </section>
    </div>
  );

  async function deleteBlog(id) {
    try {
      const response = await fetch(`${API_URL}/api/blogs/${id}`, { // ✅ Updated URL
        method: 'DELETE'
      });
      if (!response.ok) {
        throw new Error('Failed to delete blog');
      }
      setUploadedFiles(prev => prev.filter(blog => blog.id !== id));
    } catch (error) {
      console.error('Error deleting blog:', error);
      alert('Failed to delete blog. Please try again.');
    }
  }
}

export default Blog;
